import { getApiKey } from "../../utils/apiKey";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import React, { useEffect, useRef, useState } from "react";
import { apiCall_domain } from "../api";
import CategoriesList from "./CategoriesList";
import { Box, FormControl, MenuItem, Pagination, Select } from "@mui/material";
import CarFiltering from "./carFiltering";
import ProductMainCard from "../global/ProductMainCard";
import { createGlobalStyle } from "styled-components";
import Header from "../header";

const Categories = (props) => {
  const [selectedSort, setSelectedSort] = useState();
  const [paginationData, setPaginationData] = useState();
  const [defaultPriceRange, setDefaultPriceRange] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [features, setFeatures] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(true);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [priceSort, setPriceSort] = useState([
    { label: "هیچکدام", value: 6 },
    { label: "ارزان ترین", value: 2 },
    { label: "گران ترین", value: 1 },
    { label: "جدید ترین", value: 4 },
    { label: "پر فروش ترین", value: 5 },
    { label: "پر بازدید ترین", value: 3 },
  ]);
  const [brands, setBrands] = useState("");
  const [models, setModels] = useState("");
  const [types, setType] = useState("");
  const [cars, setCars] = useState("");

  useEffect(() => {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/car-types`, { headers: headers })
      .then((res) => setCars(res.data.data));
  }, []);

  const handleCarBrand = (e) => {
    setBrands(e.target.value);
    setModels("");
    setType("");
  };

  const cleanPayload = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(
        ([_, value]) =>
          value !== "" &&
          value !== null &&
          value !== undefined &&
          !(Array.isArray(value) && value.length === 0),
      ),
    );
  };

  const handleCarModel = (e) => {
    setModels(e.target.value);
    setType("");
  };
  const handleCarType = (e) => {
    setType(e.target.value);
  };
  const [appliedFilters, setAppliedFilters] = useState({ stock: false });
  const Headers = {
    Authorization: getApiKey(),
    "content-type": "application/json",
  };

  let carData;

  if (localStorage.getItem("data")) {
    carData = JSON.parse(localStorage.getItem("data"));
  }

  const defaultData = {
    page: 1,
    price_from: 0,
    price_to: 999999999,
    orderBy: 6,
    stock: 0,
    car_type_id: carData?.type ? +carData.type : "",
    car_id: carData?.car.id ? carData.car.id : "",
    car_brand_id: carData?.brand.id ? carData.brand.id : "",
  };
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    let DData = {
      page: 1,
      price_from: 0,
      price_to: 999999999,
      orderBy: 6,
      stock: 0,
      is_limited: 0,
      car_type_id: "",
      car_id: "",
      car_brand_id: "",
    };

    const paramObj = {};
    for (const [key, value] of searchParams.entries()) {
      paramObj[key] = value;
    }

    // ---------------- FEATURES ----------------
    const featuresArr = [];

    if (+paramObj.filter_type === 2 || +paramObj.filter_type === 3) {
      const featureId = +paramObj.filter_type === 3 ? 35 : 30;
      const featureValue =
        searchParams.get(`feature[${featureId}]`) || paramObj.filter_query;

      if (featureValue) {
        featuresArr.push({ id: featureId, value: featureValue });
      }
    }

    if (featuresArr.length) {
      DData.features = featuresArr;
    }

    // -------- REMOVE EMPTY VALUES --------
    DData = cleanPayload(DData);

    // ---------------- API ----------------
    const categoryId = props.match.params.subCategory
      ? props.match.params.subCategoryId
      : props.match.params.categoryId;

    axios
      .post(
        `${apiCall_domain}/customer/categories/${categoryId}/products?page=1`,
        DData,
        { headers: Headers },
      )
      .then((res) => {
        const products = res.data.products;
        const options = res.data.options;

        setPaginationData(products.meta);
        setProducts(products.data);
        setAppliedFilters({
          price_from: options.price_range.min,
          price_to: options.price_range.max,
        });
        setFilters(options.filters);
        setDefaultPriceRange([
          options.price_range.min,
          options.price_range.max,
        ]);
        setCategoryLoading(false);
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false);
        setCategoryLoading(false);
      });
  }, []);

  const getProducts = (page, isGet) => {
    setCategoryLoading(true);
    const getData = {
      features: features,
      page: page,
      stock: appliedFilters.stock ? 1 : 0,
      is_limited: appliedFilters.is_limited ? appliedFilters.is_limited : 0,
      price_from: appliedFilters.price_from,
      price_to: appliedFilters.price_to,
      orderBy: selectedSort ? selectedSort.value : 6,
      car_type_id: types?.id ? types.id : "",
      car_id: models?.id ? models.id : "",
      car_brand_id: brands?.id ? brands.id : "",
    };
    axios
      .post(
        `${apiCall_domain}/customer/categories/${
          props.match.params.subCategoryId
            ? parseInt(props.match.params.subCategoryId)
            : parseInt(props.match.params.categoryId)
        }/products?page=1`,
        isGet ? getData : defaultData,
        { headers: Headers },
      )
      .then((res) => {
        setAppliedFilters({
          stock: appliedFilters.stock,
          price_from: res?.data?.options?.price_range?.min,
          price_to: res?.data?.options?.price_range?.max,
          orderBy: selectedSort?.value,
        });
        setProducts(res.data.products.data);
        setCategoryLoading(false);
        setFilters(res.data.options.filters);
        setPaginationData(res.data.products.meta);
        setDefaultPriceRange([
          res.data.options.price_range.min,
          res.data.options.price_range.max,
        ]);
      });
    if (!isGet) {
      setSelectedSort();
    }
  };

  // useEffect(() => {
  //   getProducts(1, false);
  // }, [props.match.params.subCategoryId, props.match.params.categoryId]);

  useEffect(() => {
    if (selectedSort) {
      getProducts(1, true);
    }
  }, [selectedSort]);

  const handleStock = (e, newValue) => {
    setAppliedFilters({
      ...appliedFilters,
      stock: newValue,
    });
  };

  const changePriceRange = (e, newValue) => {
    setAppliedFilters({
      ...appliedFilters,
      price_from: newValue[0],
      price_to: newValue[1],
    });
  };

  const handleModal = () => {
    setShowFilterModal(!showFilterModal);
    if (showFilterModal) {
      setAppliedFilters({
        price_from: defaultPriceRange[0],
        price_to: defaultPriceRange[1],
      });
    }
    window.scrollTo(0, 0);
  };

  const handleOrderBy = (e) => {
    setSelectedSort(e.target.value);
  };

  const applyFilter = () => {
    getProducts(1, true);
    handleModal();
    window.scrollTo(0, 0);
  };

  const clearFilter = () => {
    setFeatures([]);
    getProducts(1, false);
    setAppliedFilters({
      price_from: defaultPriceRange[0],
      price_to: defaultPriceRange[1],
    });
    setShowFilterModal(false);
    window.scrollTo(0, 0);
  };

  const addFilter = (id, value) => {
    let state = [...features];
    const selectedFeature = state.find((feature) => +feature.id === id);
    const selectedFeatureDelete = state.findIndex(
      (feature) => +feature.id === id,
    );
    if (selectedFeature && value === "") {
      state.splice(selectedFeatureDelete, 1);
    } else if (selectedFeature) {
      selectedFeature.value = value;
      state[selectedFeatureDelete] = selectedFeature;
    } else if (value !== "") {
      state.push({ id, value });
    }
    setFeatures(state);
  };
  const checkForNumric = (id, value) => {
    const numRegex = /^[1-9][\.\d]*(,\d+)?$/;
    if (numRegex.test(value)) {
      addFilter(id, value);
    }
  };

  const checkForText = (id, value) => {
    addFilter(id, value);
  };

  const handlePagination = (event, page) => {
    getProducts(page, true);
  };

  const GlobalStyles = createGlobalStyle`body{
      background: ${!showFilterModal ? "#E5E5E5" : "#fff"};
    }`;
  const currentCategory = categories?.find(
    (category) => category.id == props.match.params.categoryId,
  );
  return loading ? (
    <Spinner />
  ) : (
    <>
      <GlobalStyles />
      {showFilterModal ? null : (
        <Header
          showSearchBar={true}
          showBasket={true}
          title={
            carData
              ? carData.brand.name + "     " + carData.car.name
              : currentCategory?.name
          }
        />
      )}
      <div className="category">
        {categories.length > 0 && (
          <CategoriesList
            categories={categories}
            selectedCategory={parseInt(props.match.params.categoryId)}
            selectedSubCategory={parseInt(props.match.params.subCategoryId)}
          />
        )}
        {categoryLoading ? (
          <Spinner />
        ) : (
          <>
            <div className="categoryFilter">
              <div
                className="filterBox"
                onClick={() => {
                  handleModal();
                }}
              >
                <i className="icon-filters" />
                <span>فیلتر بندی</span>
              </div>

              <div
                className={`carFilterModal ${
                  showFilterModal ? "showFilterModal" : null
                }`}
              >
                <CarFiltering
                  addFilter={addFilter}
                  checkForText={checkForText}
                  checkForNumric={checkForNumric}
                  handleModal={handleModal}
                  filter={filters}
                  price={[appliedFilters.price_from, appliedFilters.price_to]}
                  changePriceRange={changePriceRange}
                  handleStock={handleStock}
                  stock={appliedFilters.stock}
                  applyFilter={applyFilter}
                  clearFilter={clearFilter}
                  features={features}
                  defaultPrice={defaultPriceRange}
                  brands={brands}
                  models={models}
                  types={types}
                  cars={cars}
                  handleCarType={handleCarType}
                  handleCarModel={handleCarModel}
                  handleCarBrand={handleCarBrand}
                />
              </div>
              <div className="priceBox">
                <i className="icon-order" />

                <Box>
                  <FormControl>
                    <Select
                      onChange={handleOrderBy}
                      displayEmpty
                      value={selectedSort}
                    >
                      <MenuItem disabled> مرتب سازی</MenuItem>
                      {priceSort.map((range, index) => (
                        <MenuItem value={range} key={index}>
                          {range.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </div>
            <div
              className={` categoryProductSection ${
                products.length ? " " : "noStockCategory"
              }`}
            >
              {!showFilterModal ? (
                products.length ? (
                  products.map((item, index) => (
                    <ProductMainCard
                      data={item}
                      deadline={item.deadline}
                      countDown={false}
                      featuresStat={true}
                      features={item.features}
                      key={index}
                    />
                  ))
                ) : (
                  <div className="noProductSection">
                    <span className="noStock">هیج کالایی وجود ندارد</span>
                  </div>
                )
              ) : null}
            </div>
            {paginationData.last_page > 1 && (
              <div className="pagination">
                <Pagination
                  count={paginationData.last_page}
                  onChange={handlePagination}
                  page={paginationData.current_page}
                />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Categories;
